<router-outlet></router-outlet>

<footer class="tw-text-center tw-my-12">
  <environment-selector></environment-selector>

  <div bitTypography="body2">FusionPass Web</div>
  <div bitTypography="body2">{{ version }}</div>
  <br />
  <div bitTypography="helper" id="vw-disclaimer">
    A modified version of the Bitwarden&reg; Web Vault for FusionPass (hosted by FusionMGA).<br />
    FusionPass is not associated with the Vaultwarden project, nor the Bitwarden&reg; project, nor
    Bitwarden Inc.
  </div>
</footer>
